<template>
  <div class="ka-pc-filters">
    <div class="ka-pc-filter-group">
      <span class="ka-pc-filter-label">{{ t.metalLabel }}</span>
      <div class="ka-pc-btn-group">
        <button
          v-for="m in metals"
          :key="m.code"
          :class="['ka-pc-btn', { active: selectedMetals.indexOf(m.code) !== -1 }]"
          @click="$emit('metal', m.code)"
        >{{ m.label }}</button>
      </div>
    </div>
    <div class="ka-pc-filter-group">
      <span class="ka-pc-filter-label">{{ t.unitLabel }}</span>
      <div class="ka-pc-btn-group">
        <button
          v-for="u in units"
          :key="u.key"
          :class="['ka-pc-btn', { active: selectedUnit === u.key }]"
          @click="$emit('unit', u.key)"
        >{{ u.label }}</button>
      </div>
    </div>
    <div class="ka-pc-filter-group">
      <span class="ka-pc-filter-label">{{ t.currencyLabel }}</span>
      <div class="ka-pc-btn-group">
        <button
          v-for="c in currencyOptions"
          :key="c"
          :class="['ka-pc-btn', { active: selectedCurrency === c.toLowerCase() }]"
          @click="$emit('currency', c)"
        >{{ c }}</button>
      </div>
    </div>
    <div class="ka-pc-filter-group">
      <span class="ka-pc-filter-label">{{ t.dateLabel }}</span>
      <div class="ka-pc-date-inputs">
        <input type="date" :value="dateFrom" @change="$emit('update:dateFrom', $event.target.value)" class="ka-pc-date" />
        <span class="ka-pc-date-sep">&mdash;</span>
        <input type="date" :value="dateTo" @change="$emit('update:dateTo', $event.target.value)" class="ka-pc-date" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterBar',
  props: {
    t: { type: Object, required: true },
    metals: { type: Array, required: true },
    units: { type: Array, required: true },
    currencyOptions: { type: Array, required: true },
    selectedMetals: { type: Array, required: true },
    selectedUnit: { type: String, required: true },
    selectedCurrency: { type: String, required: true },
    dateFrom: { type: String, required: true },
    dateTo: { type: String, required: true }
  }
}
</script>
